import axios from "./axiosConfig";
import API_BASE_URL from "./apiConfig";

let token;

export const getSFExpressBearerToken = async () => {
    const response = await axios.post(
        `${API_BASE_URL}/sf-express-routes/get-token`,
    );

    return response.data.bearer_token;
};

export const SFExpress_GetArea = async () => {
    token = await getSFExpressBearerToken();
    const data = {
        token: token,
    };
    const response = await axios.post(
        `${API_BASE_URL}/sf-express-routes/get-area`,
        data,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    return response.data.area_list;
};

export const SFExpress_GetNetCode = async (typeId, areaId) => {

    const data = {
        token: token,
        typeId: typeId,
        areaId: areaId,
    };
    const response = await axios.post(
        `${API_BASE_URL}/sf-express-routes/get-netCode`,
        data,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    return response.data.netCode;
};

export const SFExpress_GetAddressList = async (lang, netCode) => {

    const data = {
        token: token,
        lang: lang,
        netCode: netCode,
    };
    const response = await axios.post(
        `${API_BASE_URL}/sf-express-routes/get-pickup-locations`,
        data,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    return response.data.addresses;
};


